var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ComComponent",
    {
      ref: "comComponent",
      attrs: {
        title: "导粉-2",
        id: _vm.id,
        keyId: _vm.keyId,
        tips: "说明：头像108*108，悬浮图标132*132，老师大图276*382",
      },
    },
    [
      [
        _c(
          "el-image",
          {
            staticClass: "img-icon",
            attrs: {
              src: "https://img-fe.tengzhihh.com/image/87eedcb4f595c2-376x473.png",
              fit: "contain",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "image-default",
                attrs: { slot: "error" },
                slot: "error",
              },
              [_c("i", { staticClass: "el-icon-picture" })]
            ),
          ]
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }